import styled from 'styled-components'

export const FormFooter = styled.div`
  text-align: center;
`
